<script setup lang="ts">
	import { computed } from 'vue'

	import { useConfigStore } from '@/stores'

	const configStore = useConfigStore()

	const isLightActive = computed<boolean>(() => {
		return configStore.colorMode === 'light'
	})
	const isDarkActive = computed<boolean>(() => {
		return configStore.colorMode === 'dark'
	})
	const isAutoActive = computed<boolean>(() => {
		return configStore.colorMode === 'auto'
	})

	function changeTheme(themeString: 'light' | 'dark' | 'auto') {
		configStore.changeTheme(themeString)
	}
</script>
<template>
	<div class="dropdown theme-control-dropdown">
		<a
			class="nav-link d-flex align-items-center dropdown-toggle fs-0 pe-1 py-0"
			href="#"
			role="button"
			data-bs-toggle="dropdown"
			aria-haspopup="true"
			aria-expanded="false"
		>
			<font-awesome-icon v-if="isLightActive" icon="sun" class="fs-2" transform="shrink-2" />
			<font-awesome-icon v-if="isDarkActive" icon="moon" class="fs-2" transform="shrink-3" />
			<font-awesome-icon v-if="isAutoActive" icon="adjust" class="fs-2" transform="shrink-3" />
		</a>
		<div
			class="dropdown-menu dropdown-menu-end dropdown-caret border py-0 mt-3"
			aria-labelledby="themeSwitchDropdown"
		>
			<div class="bg-white dark__bg-1000 rounded-2 py-2">
				<button
					class="dropdown-item d-flex align-items-center gap-2"
					type="button"
					value="light"
					data-theme-control="theme"
					:class="{ active: isLightActive }"
					@click="changeTheme('light')"
				>
					<font-awesome-icon icon="sun" />Light
					<font-awesome-icon icon="check" class="dropdown-check-icon ms-auto text-600" />
				</button>
				<button
					class="dropdown-item d-flex align-items-center gap-2"
					type="button"
					value="dark"
					data-theme-control="theme"
					:class="{ active: isDarkActive }"
					@click="changeTheme('dark')"
				>
					<font-awesome-icon icon="moon" transform="" />Dark
					<font-awesome-icon icon="check" class="dropdown-check-icon ms-auto text-600" />
				</button>
				<button
					class="dropdown-item d-flex align-items-center gap-2"
					type="button"
					value="auto"
					data-theme-control="theme"
					:class="{ active: isAutoActive }"
					@click="changeTheme('auto')"
				>
					<font-awesome-icon icon="adjust" transform="" />Auto
					<font-awesome-icon icon="check" class="dropdown-check-icon ms-auto text-600" />
				</button>
			</div>
		</div>
	</div>
</template>
